<template>
<div class="page">
  <div class="page-content">
    <div class="layoutTop"/>

    <b-container fluid>
      <b-row class="justify-content-start">
        <b-col>
          <back-button :returnUrl="'/administration/accounts/'"></back-button>
        </b-col>
        <b-col md="3" class="showLargeScreenOnly">
          <f7-button md="3" class="button-action milkyBlockBlack"
                  @click="onRefresh()">
            <f7-icon f7="refresh"></f7-icon>
            <span class="fab-label">{{ $t('common.rfrsh') }}</span>
          </f7-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="tableHeaderColored text-center">
              <span> {{ $t('administration.users_list') }} </span>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <f7-searchbar
            :cancel-link="$t('common.cncl')"
            placeholder="Search in Users"
      			search-list="#users-list"
            @searchbar:search="onUsersSearch"
            @searchbar:clear="onUsersClear">
          </f7-searchbar>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <div class="itemList">
            <spinner v-if="usersList.length === 0"></spinner>
            <f7-list media-list v-if="usersList" id="users-list">
              <f7-list-item>
                <b-row>
                  <b-col class="text-center boldLabel">
                    {{$t('administration.user_id') + ' :'}}
                  </b-col>
                  <b-col class="text-center boldLabel">
                    {{$t('administration.user_login') + ' :'}}
                  </b-col>
                </b-row>
              </f7-list-item>
              <f7-list media-list v-for="(usersGroup, key) in usersList" :key="key">
                <f7-list-item :title="key" group-title></f7-list-item>
                <f7-list-item v-bind:class="{ 'boxRequest': canGetUserAccountDetail() }" v-for="user in usersGroup" :key="user.Id">
                  <b-row @click="canGetUserAccountDetail() ? seeDetails(user) : seeDetails()">
                    <b-col class="text-center">
                      {{ user.Id }}
                    </b-col>
                    <b-col class="text-center">
                      {{ user.Login }}
                    </b-col>
                  </b-row>
                </f7-list-item>
              </f7-list>
            </f7-list>
          </div>
        </b-col>
      </b-row>

    </b-container>
    <div class="toolbarPageBottomBlank"></div>
  </div>
</div>
</template>

<script>
import backButton from '@/components/common/backButton.vue'
import spinner from '@/components/common/spinner.vue'


import {loadPage} from '@/helpers/routing'
import {errorMessageAlert} from '@/helpers/alert'

export default {
  name: 'Company',
  components: {
    'back-button': backButton,
    'spinner': spinner
  },
  props: {
    idAccount: {
      default: '0',
      type: String
    }
  },
  data () {
    return {
      correctAccent: [],
      filterBy: '',
      users: [],
      usersList: []

    }
  },
  created () {
    var tmpAccent = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÖØòóôõöøÈÉÊËèéêëÇçÌÍÎÏìíîïÙÚÛÜùúûüÿÑñ'
    var tmpWithoutAccent = 'aaaaaaaaaaaaooooooooooooeeeeeeeecciiiiiiiiuuuuuuuuynn'
    var accent = tmpAccent.split('')
    var withoutAccent = tmpWithoutAccent.split('')
    var i = -1
    while (accent[++i]) {
      this.correctAccent[accent[i]] = withoutAccent[i]
    }
    this.correctAccent['Œ'] = 'OE'
    this.correctAccent['œ'] = 'oe'
    let that = this
    this.$engine.accounts.getUserAccountsAll(this.idAccount)
    .then(resp => {
      that.users = resp.data.userAccounts
      that.setUsers()
    })
    .catch(error => {
      errorMessageAlert(error, that, that.$i18n)
    })
  },
  mounted () {
  },
  beforeDestroy () {

  },
  methods: {
    canGetUserAccountDetail () {
      return (this.$engine.user.get().rights.admin_user_detail === '1')
    },
    onUsersClear: function () {
      this.filterBy = ''
    },
    onRefresh () {
      let that = this
      this.$engine.accounts.getUserAccountsAll(this.idAccount)
      .then(resp => {
        that.users = resp.data.userAccounts
        that.setUsers()
      })
      .catch(error => {
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    onUsersSearch (query, found) {
      this.filterBy = query
      this.setUsers()
    },
    orderKeys (obj) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      return after
    },
    seeDetails: function (user = null) {
      if (!user) {
        return
      }
      if (!user.Id) {
        return
      }
      loadPage(this, {
        url: '/administration/accountDetail/' + user.Id
      })
    },
    setUsers (index = 1) {
      var listUsers = {}
      let filterBy = this.replaceAccent(this.filterBy)
      for (let userPlusKey of Object.entries(this.users)) {
        let user = userPlusKey[1]
        let login = this.replaceAccent(user.login)
        if (login.toLowerCase().includes(filterBy.toLowerCase())) {
          var firstLetter = login.substr(0, 1).toUpperCase()
          if (!listUsers.hasOwnProperty(firstLetter)) {
            listUsers[firstLetter] = []
          }
          listUsers[firstLetter].push({
            Id: user.id,
            Name: user.Name,
            Login: user.login
          })
          listUsers[firstLetter].sort((a, b) => {
            if (a === b) {
              return 0
            }
            return a.login < b.login ? -1 : 1
          })
        }
      }
      this.usersList = this.orderKeys(listUsers)
    },
    replaceAccent (strToTest) {
      if (!strToTest.length) {
        return strToTest
      }
      if (typeof strToTest === 'string') {
        var str = strToTest
        let correctAccent = this.correctAccent
        str = str.replace(/./g, function (i) {
          return (correctAccent[i]) ? correctAccent[i] : i
        })
        return str
      }
      return strToTest
    }
  }
}
</script>



// WEBPACK FOOTER //
// CompanyPage.vue?7e15671d